import React from 'react'
import PrivacyPage from './privacy-page/Privacy'


 
const Privacy = () => {
  return (
    <>
    <PrivacyPage/>
    </>
  )
}

export default Privacy